import { Component, OnInit } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-findmore-dialog',
  standalone: true,
  imports: [MatDialogModule],
  templateUrl: './findmore-dialog.component.html',
  styleUrls: ['./findmore-dialog.component.scss']
})
export class FindmoreDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<any>) { }

  ngOnInit(): void {
  }

  // Method to close the dialog
  cancel(): void {
    this.dialogRef.close();
  }
}
